import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n";
import { FAQS } from "../data/content";
import { SpecialCta } from "../components/sections/CtaSections";

export default function Faq() {
  const { lang } = useLang();
  return (
    <main>
      <Seo
        title="अक्सर पूछे जाने वाले प्रश्न (FAQ)"
        description="Anansha Welfare Society के बारे में सामान्य प्रश्न — संस्था क्या है, दान कैसे करें, स्वयंसेवक कैसे बनें, संपर्क कैसे करें।"
        path="/faq"
        breadcrumb={["सामान्य प्रश्न"]}
      />
      <PageHero
        overline={{ hi: "प्रश्नोत्तर", en: "FAQ" }}
        title={{ hi: "अक्सर पूछे जाने वाले प्रश्न", en: "Frequently Asked Questions" }}
        testid="faq-page-heading"
      />
      <section className="py-20 bg-ngo-cream">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-4">
          {FAQS.map((f, i) => (
            <Reveal key={i} i={i}>
              <details data-testid={`faq-item-${i}`} className="group bg-white rounded-2xl border border-ngo-deep/10 px-6 py-5 open:shadow-[0_14px_36px_rgba(23,107,58,0.10)] transition-shadow duration-300">
                <summary className="cursor-pointer font-semibold text-ngo-ink list-none flex items-center justify-between gap-4">
                  {lang === "hi" ? f.hi.q : f.en.q}
                  <span className="text-ngo-leaf text-xl group-open:rotate-45 transition-transform duration-300">+</span>
                </summary>
                <p className="mt-4 text-sm leading-relaxed text-ngo-ink/70">{lang === "hi" ? f.hi.a : f.en.a}</p>
              </details>
            </Reveal>
          ))}
        </div>
      </section>
      <SpecialCta />
    </main>
  );
}
